import { connect } from "react-redux";
import _ from "lodash";

import { fetchEngagementUniqueViewersGraphReport } from "src/legacy/redux/actions/reports.jsx";
import withUseHooks from "src/legacy/components/withUseHooks";

import UniqueViewersView from "./view";

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.legacyRootReducer.reports.engagement.uniqueViewers.loading,
    data: state.legacyRootReducer.reports.engagement.uniqueViewers.item,
    count : _.sumBy(state.legacyRootReducer.reports.engagement.uniqueViewers.item, (item) => item.value) 

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEngagementUniqueViewersGraphReport: (filter) => {
      return dispatch(fetchEngagementUniqueViewersGraphReport(filter));
    },
  };
};

const UniqueViewersContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UniqueViewersView);

export default withUseHooks(UniqueViewersContainer);